export default {
  isLoading: state => state.isLoading,
  isMobile: state => state.isMobile,
  headingText: state => state.settings.headingText,
  subHeadingText: state => state.settings.subHeadingText,
  customLinkUrl: state => state.settings?.customLinkUrl,
  customLinkLabel: state => state.settings?.customLinkLabel,
  backgroundColor: state => state.settings?.backgroundColor,
  textColor: state => state.settings?.textColor,
  isWidgetOpen: state => state.isWidgetOpen,
  widgets: state => state.widgets,
  parentHeight: state => state.parentHeight,
  parentWidth: state => state.parentWidth,
  settings: state => state.settings,
  isSettingsAvailable: state => Object.keys(state.settings).length > 0,
  practiceLocations: state => state.practiceLocations,
  isMobileSafari: state => state.isMobileSafari
}
